(function () {
  const LAUNCHER_ID = 'silbon-zd-launcher';

  function getLauncher() {
    return document.getElementById(LAUNCHER_ID);
  }

  function hideLauncher() {
    const launcher = getLauncher();
    if (!launcher) return;
    launcher.style.display = 'none';
  }

  function showLauncher() {
    const launcher = getLauncher();
    if (!launcher) return;
    launcher.style.display = 'grid';
  }

  function openZendesk() {
    // Al click: abre y esconde botón (así no pisa el input)
    hideLauncher();

    // Messaging
    try {
      window.zE('messenger', 'show');
      window.zE('messenger', 'open');
      return;
    } catch (e) {}

    // Classic
    try {
      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
      return;
    } catch (e) {}

    // Si no pudo abrir, vuelve a mostrar el botón
    showLauncher();
  }

  function bindOnce() {
    const launcher = getLauncher();
    if (!launcher) return false;

    if (launcher.dataset.zdBound === '1') return true;
    launcher.dataset.zdBound = '1';

    launcher.addEventListener('click', openZendesk);
    return true;
  }

  function initWhenZendeskReady() {
    if (!window.zE) return false;

    // Asegura botón visible
    showLauncher();

    // Oculta launcher nativo de Zendesk
    try { window.zE('messenger', 'hide'); } catch (e) {}
    try { window.zE('webWidget', 'hide'); } catch (e) {}

    // Asegura cerrado al cargar
    try { window.zE('messenger', 'close'); } catch (e) {}
    try { window.zE('webWidget', 'close'); } catch (e) {}

    // Eventos open/close -> hide/show
    try {
      window.zE('messenger:on', 'open', hideLauncher);
      window.zE('messenger:on', 'close', showLauncher);
    } catch (e) {}

    try {
      window.zE('webWidget:on', 'open', hideLauncher);
      window.zE('webWidget:on', 'close', showLauncher);
    } catch (e) {}

    return true;
  }

  function boot() {
    // Espera a que exista el botón en DOM
    const launcherReady = bindOnce();

    // Espera a Zendesk
    const zendeskReady = initWhenZendeskReady();

    if (launcherReady && zendeskReady) return;
    setTimeout(boot, 100);
  }

  // Arranca
  boot();
})();